<template>
    <div class="home">
        <section class="image-gallery">
            <div class="image" v-for="item in items" :key="item.id">
                <h2>{{item.title}}</h2>
                <img :src="item.path" />
                <!-- if description was updated, displayed updated description, else display the original-->
                <div v-if="item.descriptionUpdated">
                    <p>{{item.newDescription}}</p>
                </div>
                <div v-else>
                    <p>{{item.description}}</p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios';
export default {
  name: 'Home',
    data() {
        return {
            items: [], //array of all the items in the museum
        }
    },
    created() {
        this.getItems(); //getItems() is called when vue is first loaded on the page
    },
    methods: {
        async getItems() {
            try {
                //uses axios library to get items from server and store them in items
                //bec we use await, this needs to be an async method
                //vue.config.js will know that we aren't use a vue router api, so we go to backend
                let response = await axios.get("/api/items");
                this.items = response.data; //back end sends us our items
                return true;
            } catch (error) {
                console.log(error);
            }
        },
    }
}
</script>

<style scoped>
    .image h2 {
        font-style: italic;
    }

    /* Masonry */
    *,
    *:before,
    *:after {
        box-sizing: inherit;
    }

    .image-gallery {
        column-gap: 1.5em;
    }

    .image {
        margin: 0 0 1.5em;
        display: inline-block;
        width: 100%;
    }

    .image img {
        width: 100%;
    }

    /* Masonry on large screens */
    @media only screen and (min-width: 1024px) {
        .image-gallery {
            column-count: 4;
        }
    }

    /* Masonry on medium-sized screens */
    @media only screen and (max-width: 1023px) and (min-width: 768px) {
        .image-gallery {
            column-count: 3;
        }
    }

    /* Masonry on small screens */
    @media only screen and (max-width: 767px) and (min-width: 540px) {
        .image-gallery {
            column-count: 2;
        }
    }
</style>